import { pathOr } from 'ramda';
import { getCityFromAddress } from './googleMaps';

const getOwnListings = async (sdk) => {
  try {
    const response = await sdk.ownListings.query({});
    const listings = pathOr([], ['data', 'data'], response);

    return listings;
  }
  catch (e) {
    return null
  }
};

export const updateOwnListingsCities = async (sdk) => {
  try {
    const listings = await getOwnListings(sdk);
    if (listings.length === 0) return;

    for (const listing of listings) {
      const currentCity = pathOr(null, ['attributes', 'publicData', 'location', 'city'], listing);
      if (currentCity) continue;
      const address = listing.attributes.publicData.location.address;
      const city = await getCityFromAddress(address);

      const params = {
        id: listing.id,
        publicData: {
          location: {
            address,
            city,
          },
        },
      }
      
      await sdk.ownListings.update(params);
    }

  }
  catch (e) {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/util/swimmyOnLoginActions.js